import React, { useEffect, useState } from 'react';
import { Text, Button, Card, Layout, Input, Select } from '@ui-kitten/components';
import { StyleSheet, View, Platform } from 'react-native';
import { getCurrentUser } from '../../utils/getCurrentUser';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { M_CREATE_CAMPAIGN, M_UPDATE_CAMPAIGN } from './../../data/api/mutation/m_campaigns';
import { Q_GET_CAMPAIGN } from '../../data/api/query/q_campaigns';
import { PageLoadingIndicator } from '../../components/LoadingIndicator';
import { useScreenDimensions, getItemWidth } from '../../utils/useScreenInfo';


const useInputChanges = (initialValue = '') => {
    const [value, setValue] = React.useState(initialValue);
    return {
        value,
        onChangeText: setValue,
    };
};


export default function EditCampaignScreen({ navigation, route }): React.ReactElement {
    const { isMediumScreenOrLarger, isLargeScreenOrLarger } = useScreenDimensions();
    const { pageSpacerHorizontal } = getItemWidth({ isMediumScreenOrLarger, isLargeScreenOrLarger });
    const params = route?.params;
    console.log({ navigation, route, params });

    const [campaignLoaded, setCampaignLoaded] = useState(false);
    const titleInput = useInputChanges();
    const descInput = useInputChanges();
    const [updateCampaign, { data, loading, error }] = useMutation(M_UPDATE_CAMPAIGN);
    const campaignResponse = useQuery(Q_GET_CAMPAIGN, {
        variables: { campaign_id: params.campaign },
        fetchPolicy: 'network-only'
    });
    useEffect(() => {
        if (campaignLoaded === false) {      
            const campaign: any = (campaignResponse?.data?.campaigns) ? campaignResponse.data.campaigns[0] : undefined;
            console.log('useHook campaign = ', campaign);
            if (campaign) {
                titleInput.onChangeText(campaign.title);
                descInput.onChangeText(campaign.description);
                setCampaignLoaded(true);
            }
        }
    });



    if (campaignResponse.loading) return <Text>Loading...</Text>;
    if (campaignResponse.error) return <Text>Error :(</Text>;
    console.log('we have data, ', campaignResponse.data, titleInput, descInput);





    const onSubmit = () => {
        const user: any = getCurrentUser();
        const newParams: any = {
            campaign_id: params.campaign,
            title: titleInput.value,
            description: descInput.value
        };
        console.log(newParams, user);
        updateCampaign({ variables: newParams});
    }

    if (loading) {
        return (
            <PageLoadingIndicator />
        );
    }
    if (error) {
        console.log(`ERROR: const [updateCampaign, { data, loading, error }] = useMutation(M_UPDATE_CAMPAIGN);`, error)
        return (
            <>
                <Text>{'There was an error with the request'}</Text>
            </>
        );
    }
    if (data) {
        console.log(`const [{ data }] = useMutation(M_UPDATE_CAMPAIGN);`, data)
    }

    const renderHeader = (): React.ReactElement => (
        <View style={{ padding: 30 }}>
            <Text category='h2'>{'Edit Campaign'}</Text>
            {/* <Text category='s1'>{description}</Text> */}
        </View>
    );
    const renderFooter = (): React.ReactElement => (
        <View style={styles.footerContainer}>
            <Button onPress={onSubmit} style={styles.footerControl}>{'SAVE'}</Button>
            <Button style={styles.footerControl} status='basic' onPress={() => navigation.goBack()}>{'CANCEL'}</Button>
        </View>
    );

    return (
        <Layout level='3' style={{ flex: 1, padding: pageSpacerHorizontal }}>
            <Card header={renderHeader} footer={renderFooter}>
                <Input
                    style={styles.input}
                    size='large'
                    placeholder='Camaign Title'
                    label='Camaign Title'
                    {...titleInput}
                />
                <Input
                    style={styles.input}
                    size='large'
                    placeholder='Camaign Description'
                    label='Camaign Description'
                    {...descInput}
                />
            </Card>
        </Layout>
    );

}


const styles = StyleSheet.create({
    input: {
        margin: 10,
    },
    footerContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        margin: 10,
        marginRight: 10,
    },
    footerControl: {
        // marginTop: 5,
        // marginBottom: 5,
        // paddingLeft: 10
    },
});